<template>
  <service-component/>
</template>

<script>
import ServiceComponent from '@/spa/components/board/service/BoardService';

export default {
  name: 'ServicePage',
  components: {
    ServiceComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/operation/ServicePage.vue